import axios from "axios";

const BASE_URL = "https://lms.childinfo.in/api";

export const getVideos = async (token, params = {}) => {
  return axios.get(`${BASE_URL}/videos.php`, {
    headers: { Authorization: `Bearer ${token}` },
    params: params, // <-- supports id, class_id, subject_id, etc.
  });
};

export const updateVideo = async (token, id, data) => {
  return axios.put(`${BASE_URL}/videos.php?id=${id}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
